import React, { useState, useEffect } from 'react';
import CloseButton from '../../../../sharecomponents/CloseButton';
import Post from '../../../../../utils/Post';
import VainillaDialog from '../../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../../utils/Verifiers.jsx';
import { id } from 'date-fns/locale';

const AgregarClasificacion = (p) => {
    const update = p.data ? true : false;
    const [data, setdata] = useState({
        clasificacion: p.data?.clasificacion ?? '',
        id: p.data?.id
    });
    const close = p.close ?? (() => { });
    const title = p.title ?? '';
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    useEffect(() => {

    }, []);

    const APISend = async (action, data) => {
        let resp = await Post(`/mipe/clasificacion/${action}`, { ...data }, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error', 'error');
            return;
        }
        close(resp.data);
    }

    const add = () => {
        if (data.clasificacion.trim() === '') {
            Verifiers.activeDialog(setdialog, 'El nombre de la clasificación no puede estar vacío', 'Error', 'error');
            return;
        }
        if (!update) APISend('add', { clasificacion: data.clasificacion });
        else if (update) APISend('update', { id: data.id, clasificacion: data.clasificacion });
    }

    const deleteReg = () => APISend('delete', { id: data.id });

    const confirmDelete = () => setdialog({
        tipo: "error",
        show: true,
        title: "CONFIRME PARA CONTINUAR",
        body: "¿Realmente desea eliminar este registro de clasificación? Esta acción no se puede deshacer.",
        respYes: "Si, eliminar",
        respNot: "Cancelar",
        funct: (resp) => { if (resp) deleteReg(); setdialog({ show: false }) },
        size: 'm'
    })

    return (
        <div className='vw-100 vh-100 blur-l dosis p-1' style={{ zIndex: 999, top: 0, left: 0, position: "fixed" }}>
            <CloseButton close={() => close(false)} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='col-auto p-1 ps-3 pe-3 round-xxl bg-white shadow h4 text-300'>{title} <span className='text-m text-bold ms-2'>{update ? 'Actualizar' : 'Nuevo'}</span> </div>
                <div className='w-100 m-0 p-0' />
                <div className='bw-800 bg-white shadow-multi round-m p-2 mt-2 mb-5'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className={'bw-400 mt-2'}>
                            <label className='text-bold text-s w-100 ps-3'>Clasificación</label>
                            <input className='form-control form-control-sm shadow round-m'
                                name='clasificacion' type='text' value={data.clasificacion} onChange={(e) => setdata({ ...data, [e.target.name]: e.target.value })} />
                        </div>
                        <div className='w-100' />
                        {
                            update && <div className='bw-200 mt-3 mb-4'>
                                <button className='btn btn-danger btn-sm w-100 shadow round-xxl text-bold' onClick={confirmDelete}>Eliminar</button>
                            </div>
                        }
                        <div className='bw-350 mt-3 mb-4'>
                            <button className='btn btn-warning btn-sm w-100 shadow round-xxl text-bold' onClick={add}>{update ? 'Actualizar' : 'Agregar'}</button>
                        </div>
                    </div>
                </div>
            </div>
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default AgregarClasificacion;